import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the WasteAcceptanceFormScreen state domain
 */

const selectWasteAcceptanceFormScreenDomain = state =>
  state.wasteAcceptanceFormScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by WasteAcceptanceFormScreen
 */

const makeSelectWasteAcceptanceFormScreen = () =>
  createSelector(
    selectWasteAcceptanceFormScreenDomain,
    substate => substate,
  );

export default makeSelectWasteAcceptanceFormScreen;
export { selectWasteAcceptanceFormScreenDomain };
